export const policyRoutePaths = {
  privacyPolicy: {
    path: 'privacy-policy',
    fullPath: '/privacy-policy',
  },
  // TRAD-2249 — authRoutePaths.terms 에서 이동. URL(`/terms`)은 그대로라 기존 링크·북마크·
  // 외부 공유 링크가 전부 유효하다(라우트 그룹만 바뀐다).
  terms: {
    path: 'terms',
    fullPath: '/terms',
  },
  // TRAD-3759 G4 — 하우스 룰. `/terms` 는 이용약관 자리(게시 전까지는 플래그로 하우스 룰).
  houseRule: {
    path: 'house-rule',
    fullPath: '/house-rule',
  },
  support: {
    path: 'support',
    fullPath: '/support',
  },
};
